/* eslint-disable global-require */
// Datos del comercio (fuente única de verdad para páginas legales, footer, login y recibos).
export default {
  name: "Televiaducto",
  legalName: "TELEVIADUCTO SRL",
  website: "PENDIENTE", // dominio real aún no confirmado por el cliente
  logo: require("@/assets/images/logo/client-logo.png"),
  address: "Calle Sánchez, esquina Ángel",
  municipality: "Moca",
  province: "Espaillat",
  postalCode: "PENDIENTE",
  country: "República Dominicana",
  phone: "809-578-3886",
  email: "info@televiaducto.com.do",
  currency: "DOP",
  currencyLabel: "RD$",
}
